import classNames from 'clsx';
import React, { useState } from 'react';

import styles from './Table.scss';
import Arrow from './assets/arrow-right.svg';

interface Props {
  enable: boolean;
}

const TableSlider: React.FC<React.PropsWithChildren<Props>> = ({ children, enable }) => {
  const ref = React.createRef<HTMLDivElement>();
  const [scroll, setScroll] = useState({ left: false, right: true });

  const handleScroll = (event: React.UIEvent) => {
    const elementWidth = ref.current?.getBoundingClientRect().width;
    const { scrollLeft } = event.target as Element;

    if (scrollLeft === 0) {
      setScroll({ left: false, right: true });
    } else if (elementWidth && scrollLeft >= elementWidth) {
      setScroll({ left: true, right: false });
    } else {
      setScroll({ left: false, right: false });
    }
  };

  if (!enable) return <div className={styles.tableContainer}>{children}</div>;

  return (
    <div className={styles.sliderContainer}>
      <div
        className={classNames(styles.iconContainer, styles.left, { [styles.show]: scroll.left })}
        onClick={() => {
          setScroll({ left: false, right: true });
          ref.current?.scrollTo({
            left: ref.current.getBoundingClientRect().width * -1,
            behavior: 'smooth'
          });
        }}
      >
        <Arrow />
      </div>
      <div ref={ref} onScroll={handleScroll} className={styles.tableContainer}>
        {children}
      </div>
      <div
        className={classNames(styles.iconContainer, styles.right, {
          [styles.show]: scroll.right
        })}
        onClick={() => {
          setScroll({ left: true, right: false });
          ref.current?.scrollTo({
            left: ref.current.getBoundingClientRect().width,
            behavior: 'smooth'
          });
        }}
      >
        <Arrow />
      </div>
    </div>
  );
};

export default TableSlider;
